// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RequestScaleUp
 */
export interface RequestScaleUp {
  /**
   * Duration specifies how long the scaling operation should last.
   *
   * Examples:
   *   1h
   *   30m
   *   4h30m
   * @type {string}
   * @memberof RequestScaleUp
   */
  duration?: string;
}

/**
 * Check if a given object implements the RequestScaleUp interface.
 */
export function instanceOfRequestScaleUp(
  value: object,
): value is RequestScaleUp {
  return true;
}

export function RequestScaleUpFromJSON(json: any): RequestScaleUp {
  return RequestScaleUpFromJSONTyped(json, false);
}

export function RequestScaleUpFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestScaleUp {
  if (json == null) {
    return json;
  }
  return {
    duration: json['duration'] == null ? undefined : json['duration'],
  };
}

export function RequestScaleUpToJSON(json: any): RequestScaleUp {
  return RequestScaleUpToJSONTyped(json, false);
}

export function RequestScaleUpToJSONTyped(
  value?: RequestScaleUp | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    duration: value['duration'],
  };
}
